import { render } from "./AuthOfficialBusinessDetails.vue?vue&type=template&id=52af8bc5&scoped=true"
import script from "./AuthOfficialBusinessDetails.vue?vue&type=script&lang=js"
export * from "./AuthOfficialBusinessDetails.vue?vue&type=script&lang=js"

import "./AuthOfficialBusinessDetails.vue?vue&type=style&index=0&id=52af8bc5&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52af8bc5"]])

export default __exports__